import { useAppSelector } from "features/store";
import { ReactNode } from "react";
import { Navigate } from "react-router-dom";

type CalibrateAdminRouteProps = {
  children: ReactNode;
  allowRegularInternalUsers?: boolean;
  allowPartnershipTeam?: boolean;
};

const CalibrateAdminRoute = ({
  children,
  allowRegularInternalUsers = false,
  allowPartnershipTeam = false,
}: CalibrateAdminRouteProps): JSX.Element => {
  const { isAuthenticated, user } = useAppSelector((state) => state.auth);

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  const pp = user?.platform_profile;

  if (user && !user.is_pass_reset && !(pp && !pp.is_pass_reset)) {
    return <Navigate to="/reset-password" replace />;
  }

  const isPartnershipTeam = !!pp && !pp.is_archived && pp.is_partnership_team === true;
  const isRegularInternalUser =
    !!pp &&
    !pp.is_archived &&
    pp.user_type === "internal" &&
    !pp.is_superuser &&
    !pp.is_calibrate_manager &&
    !isPartnershipTeam;
  const isPlatformAdmin =
    !!pp && !pp.is_archived && (pp.is_superuser || pp.is_calibrate_manager);

  const hasAccess =
    isPlatformAdmin ||
    (allowRegularInternalUsers && isRegularInternalUser) ||
    (allowPartnershipTeam && isPartnershipTeam);

  if (!user || !hasAccess) {
    return <Navigate to="/" replace />;
  }

  return <>{children}</>;
};

export default CalibrateAdminRoute;
